<template>
  <ul class="kt-nav kt-margin-t-10 kt-margin-b-10">
    <template v-if="pendenciasAprovador.length > 0">
      <li
        class="kt-nav__item"
      >
      <a
          class="kt-nav__link"
        >
        <span v-if="usuario.usuario.tipoUsuario == 3" class="kt-nav__link-text"> Existem {{count}} registros pendentes para aprovação</span>
        <span v-if="usuario.usuario.tipoUsuario == 4" class="kt-nav__link-text"> Existem {{count}} registros pendentes para visualização</span>

        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <span>
          <download-excel
                  :data="configExportar.pendenciasExportar"
                  :name="configExportar.nomeArquivo"
                >
                  <v-btn
                    title="Download"
                    color="success"
                    small
                    :disabled="pendenciasAprovador.length === 0"
                  >
                    <v-icon>mdi-file-excel</v-icon>
                  </v-btn>
            </download-excel>
        </span>
          
      </a>
      </li>
    </template>
  </ul>
</template>

<script>
import ApiService from "@/common/services/http/api.service";
import SweetAlert from "@/common/services/sweetalert.service";

export default {

  name: "KTDropdownNotifications",
  data() {
    return {
      usuario: {
        usuario: {
          nome: "",
        },
      },
      cliente: {},
      pendenciasAprovador: [],
      configExportar: {
        pendenciasExportar: [],
        nomeArquivo: "",
      },
      count: 0,
    };
  },
  methods: {
    adicionarMascara(item, valor) {
      switch (item) {
        case 1:
          return this.cpf(valor);
        case 2:
          return this.cnpj(valor);
        default:
          return valor;
      }
    },
    cnpj(v) {
      v = v.replace(/\D/g, "");
      v = v.replace(/^(\d{2})(\d)/, "$1.$2");
      v = v.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
      v = v.replace(/\.(\d{3})(\d)/, ".$1/$2");
      v = v.replace(/(\d{4})(\d)/, "$1-$2");
      return v;
    },

    cpf(v) {
      v = v.replace(/\D/g, "");
      v = v.replace(/(\d{3})(\d)/, "$1.$2");
      v = v.replace(/(\d{3})(\d)/, "$1.$2");
      v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
      return v;
    },
    listaPendenciasAprovador() {
        return new Promise((resolve) => {
          ApiService.get("registro", "ListarPendenciasAprovador", {
            clienteID: this.cliente.id
          }).then(({ data }) => {
            if (data.success) {
              resolve(data);
              this.pendenciasAprovador = data.data;
              this.count = this.pendenciasAprovador.length;

              this.prepararPendenciasExportar();
              if(this.count > 0){
                this.$emit(
                  "notifications-count",
                  this.pendenciasAprovador.length
                ); 
              }

            } else{
              SweetAlert.sweetAlertError(data.errors);
            } 
          });
        });
    },

    listaPendenciasEmpresa() {
        return new Promise((resolve) => {
          ApiService.get("registro", "ListarPendenciasEmpresa", {
            clienteID: this.cliente.id,
            empresaID: 0
          }).then(({ data }) => {
            if (data.success) {
              resolve(data);
              this.pendenciasAprovador = data.data;
              this.count = this.pendenciasAprovador.length;
              this.prepararPendenciasExportar();
              if(this.count > 0){
                this.$emit(
                  "notifications-count",
                  this.pendenciasAprovador.length
                );
              }

            } else{
              SweetAlert.sweetAlertError(data.errors);
            } 
          });
        });
    },

    prepararPendenciasExportar() {
      const pendenciasExportar = this.pendenciasAprovador.map((p) => {
        return {
          Entidade: p.propriedadesEntidade
            .map((pe) =>
              pe.propriedadeInteligenteID
                ? `${pe.nome}: ${this.adicionarMascara(
                    pe.propriedadeInteligenteID,
                    pe.valor
                  )}`
                : `${pe.nome}: ${pe.valor}`
            )
            .join(", "),
          "Documento Pendente": p.documento,
          Período: p.periodo,
          Status: p.statusPendenciaNome,
          Grupo: p.grupo,
          Departamento: p.departamento,
          Empresa: p.empresa,
        };
      });

      this.configExportar.pendenciasExportar = pendenciasExportar;
      this.configExportar.nomeArquivo = `Pendencias-${Date.now()}`;
    },
  },
  computed: {
  },
   mounted() {
    this.usuario = JSON.parse(window.localStorage.getItem("usuario"));
    if (this.usuario == null) {
      this.usuario = {
        usuario: {
          nome: "",
        },
      };
    }

    this.cliente = JSON.parse(window.localStorage.getItem("cliente"));
    if (this.cliente == null) {
      this.cliente = {
        caminhoVisualizacao: "",
      };
    }

    if(this.usuario.usuario.tipoUsuario == 3){
      this.listaPendenciasAprovador();
    }
    else if(this.usuario.usuario.tipoUsuario == 4){
      this.listaPendenciasEmpresa();
    }
      
  },
};
</script>
